import { Image } from '@shopify/hydrogen'
import { MouseEventHandler } from 'react'
import { AcfImage as AcfImageType } from '../lib/acf'

export const AcfImage: React.FC<{
  acf: AcfImageType[]
  className?: string
  onClick?: MouseEventHandler<HTMLImageElement>
}> = ({ acf, className, onClick }) => {
  if (!acf) {
    return null
  }

  const [image] = acf

  if (!image) {
    return null
  }

  return (
    <Image
      alt={image.alt ?? ''}
      className={className}
      height={image.height ?? 'auto'}
      onClick={onClick}
      src={image.cloudinary_src}
      width={image.width ?? 'auto'}
    />
  )
}
